import Zeppelin from './01-Betsolutions-Zeppelin.png'
import Plinko from './02-Betsolutions-Plinko.png'
import High_Low from './03-Betsolutions-Highlow.png'
import Dice from './04-Betsolutions-Dice.png'
import Mines from './05-Betsolutions-Mines.png'
import WW2 from './06-Betsolutions-WW2.png'
import Captain_Of_Pirates from './07-Betsolutions-Captain-of-Pirates.png'
import The_Mystery_of_Faberge from './08-Betsolutions-The-Mystery-of-Faberge.png'
import Backgammon from './09-Betsolutions-Backgammon.png'
import Okey from './10-Betsolutions-Okey.png'
import Bura from './11-Betsolutions-Bura.png'
import Dominoes from './12-Betsolutions-Dominoes.png'
import Seka from './13-Betsolutions-Seka.png'
import Poker_Room from './14-Betsolutions-Poker-Room.png'
import Underground_Tuning from './15-Betsolutions-Underground-Tuning.png'
import Night_Life from './16-Betsolutions-Night-Life.png'
import Legend_of_Maasai from './17-Betsolutions-Legend-of-Maasai.png'
import Betting_Shop from './18-Betsolutions-Betting-Shop.png'
import Drunk_Santa from './19-Betsolutions-Drunk-Santa.png'
import Sultans_gift from './20-Betsolutions-Sultans-Gift.png'
import Allslots from './all.png'

export default [
  { id: 7001, productId: 3, type: "betsolutions", name: "Zeppelin", img: Zeppelin },
  { id: 7004, productId: 3, type: "betsolutions", name: "Plinko", img: Plinko },
  { id: 7000, productId: 3, type: "betsolutions", name: "High Low", img: High_Low },
  { id: 7002, productId: 3, type: "betsolutions", name: "Dice", img: Dice },
  { id: 7003, productId: 3, type: "betsolutions", name: "Mines", img: Mines },
  { id: 9, productId: 2, type: "betsolutions", name: "WW2", img: WW2 },
  { id: 2, productId: 2, type: "betsolutions", name: "Captain Of Pirates", img: Captain_Of_Pirates },
  { id: 3, productId: 2, type: "betsolutions", name: "The Mystery of Faberge", img: The_Mystery_of_Faberge },
  { id: 5000, productId: 1, type: "betsolutions", name: "Backgammon", img: Backgammon },
  { id: 5001, productId: 1, type: "betsolutions", name: "Okey", img: Okey },
  { id: 5002, productId: 1, type: "betsolutions", name: "Bura", img: Bura },
  { id: 5003, productId: 1, type: "betsolutions", name: "Dominoes", img: Dominoes },
  { id: 5004, productId: 1, type: "betsolutions", name: "Seka", img: Seka },
  { id: 7, productId: 2, type: "betsolutions", name: "Poker Room", img: Poker_Room },
  { id: 1, productId: 2, type: "betsolutions", name: "Underground Tuning", img: Underground_Tuning },
  { id: 10, productId: 2, type: "betsolutions", name: "Night Life", img: Night_Life },
  { id: 5, productId: 2, type: "betsolutions", name: "Legend of Maasai", img: Legend_of_Maasai },
  { id: 6, productId: 2, type: "betsolutions", name: "Betting Shop", img: Betting_Shop },
  { id: 4, productId: 2, type: "betsolutions", name: "Drunk Santa", img: Drunk_Santa },
  { id: 8, productId: 2, type: "betsolutions", name: "Sultans gift", img: Sultans_gift },
]

export const allSlotsImage = Allslots;


// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/betsolutions/assets/index.js